import { ButtonBase, Skeleton } from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FilestoreImage } from '@omnea-app/fe-documents/FilestoreImage'
import { ImageLightbox } from '@omnea-app/omui/ImageLightbox'

type Props = {
  filestoreId: string
  alt?: string
}

export const CommentImage = ({ filestoreId, alt }: Props) => {
  const { t } = useTranslation('requests')
  const [isExpanded, setIsExpanded] = useState(false)

  const loadingFallback = <Skeleton variant="rounded" width={300} height={200} sx={{ maxWidth: '100%' }} />

  return (
    <>
      <ButtonBase
        onClick={() => setIsExpanded(true)}
        aria-label={t('request-comments.images.expand')}
        sx={{ borderRadius: 2, verticalAlign: 'bottom' }}
      >
        <FilestoreImage
          filestoreId={filestoreId}
          alt={alt ?? ''}
          loadingFallback={loadingFallback}
          sx={{ maxWidth: '100%', maxHeight: 200, borderRadius: 2, objectFit: 'contain' }}
        />
      </ButtonBase>
      <ImageLightbox
        open={isExpanded}
        onClose={() => setIsExpanded(false)}
        closeLabel={t('request-comments.images.close-preview')}
      >
        <FilestoreImage
          filestoreId={filestoreId}
          alt={alt ?? ''}
          loadingFallback={<Skeleton variant="rounded" width="90vw" height="90vh" />}
          sx={{ maxWidth: '90vw', maxHeight: '90vh', objectFit: 'contain' }}
        />
      </ImageLightbox>
    </>
  )
}
